module.exports = __webpack_public_path__ + "img/jiedi.d12b2762.jpg";